module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-meet-the-team"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), _c('Header'), (_vm.props) ? _c('div', {
    staticClass: "inner-page"
  }, [_c('div', {
    staticClass: "subnav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/meet-dr-kevin-oliveira"
    }
  }, [_vm._v("Meet Dr. Kevin Oliveira")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/meet-the-team"
    }
  }, [_vm._v("Meet the Team")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/what-sets-us-apart"
    }
  }, [_vm._v("What Sets Us Apart")])], 1)])]), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "left-area"
  }, [_c('H1', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })], 1)])])]) : _vm._e(), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c286cf2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/meet-the-team/meet-the-team.pug
// module id = 1293
// module chunks = 1